import React, { Component } from 'react'
import DocumentTitle from 'react-document-title'
import { extendObservable } from 'mobx'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import Header from '@components/Details/Header'
import Spinner from '@components/spinner'
import { DatePicker } from '@components/DatePicker'
import InfoBox from '@components/InfoBox'
import InfoIcon from '@components/Icon/Info'

import { configurationApi } from '@atheneum/api'

class BookingStorePage extends Component {
  static propTypes = {
    growlStore: PropTypes.object
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      bookingStopDate: null,
      loading: true
    })

    this.getBookingStopDate()
  }

  getBookingStopDate = async () => {
    try {
      this.bookingStopDate = await configurationApi.getByKey('BOOKING_STOP_DATE')

      this.loading = false
    } catch (err) {
      this.props.growlStore.showError(err.message)
    }
  }

  handleDateChange = async date => {
    const { growlStore } = this.props

    try {
      await configurationApi.update(this.bookingStopDate.id, {
        ...this.bookingStopDate,
        value: date
      })
      this.bookingStopDate.value = date
      growlStore.showSuccess('Booking stop date successfully updated')
    } catch (err) {
      growlStore.showError(err.message)
    }
  }

  render () {
    const { loading } = this

    if (loading) {
      return <Spinner />
    }

    return (
      <DocumentTitle title='Booking stop | Atheneum Partners'>
        <div>
          <div className='expert-search'>
            <div className='project-wrapper'>
              <Header>
                <div className='info info--noLeft'>
                  <div className='name-status-wrapper'>
                    <h1>Booking stop</h1>
                  </div>
                </div>
              </Header>
              <div className='booking-stop-wrapper'>
                <div className='expert-form__input-group'>
                  <label className='expert-form__label'>
                    Booking stop date
                  </label>
                  <DatePicker
                    dateOnly
                    date={this.bookingStopDate.value}
                    onChange={this.handleDateChange}
                  />
                </div>
                <InfoBox theme='blue' icon={<InfoIcon />}>
                  This date is used to restrict document date on invoices,
                  credit notes and general adjustments so that it cannot be set
                  to any date before this date
                </InfoBox>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('growlStore')(observer(BookingStorePage))
